import { render, staticRenderFns } from "./img_extension.vue?vue&type=template&id=50eee305&scoped=true&"
import script from "./img_extension.vue?vue&type=script&lang=js&"
export * from "./img_extension.vue?vue&type=script&lang=js&"
import style0 from "./img_extension.vue?vue&type=style&index=0&id=50eee305&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eee305",
  null
  
)

export default component.exports